export default function ({ store, redirect }) {
  if (
    store.state.auth.loggedIn &&
    store.state.auth.user.roles &&
    store.state.auth.user.roles.includes('publisher')
  ) {
    return redirect('/');
  }
}
